import { cloneDeep } from 'lodash';
import { SimpleCrudController } from '../../../../components/simpleCrud/simpleCrud.controller';
import AssistantsController, {
  Assistant
} from '../../assistants/assistants.controller';
import OffersController, { Offer } from '../../offers/offers.controller';
import { Shop } from '../shops.controller';

export default class ShopCrudController extends SimpleCrudController {
  assistants;
  offers;
  shops;

  /*@ngInject*/
  constructor(Assistant, Offer, User, $timeout) {
    super($timeout);
    this.assistants = Assistant.query();
    this.offers = Offer.query();
    this.shops = User.shops();
  }
  getAvailableShops(element) {
    // console.log('this.list.filter(e => e !== element)', element, this.list.filter(e => e !== element));

    return this.shops.filter(
      s =>
        !this.list
          .filter(e => (element ? e._id !== element._id : true))
          .find(e => this.checkShop(e, s))
    );
  }
  checkShop(element, shop) {
    if (element.user) {
      if (element.user === shop._id) {
        // console.log('checkShop found', element, shop);
        return true;
      } else if (element.user._id === shop._id) {
        // console.log('checkShop found', element, shop);
        return true;
      }
    }
    // console.log('checkShop not found', element, shop);
    return false;
  }
  edit(element) {
    this.newModel = cloneDeep(element);
    // console.log('newModel', cloneDeep(this.newModel), 'element', element);

    this.newModel.assistantList = [];
    this.newModel.availableOfferList = [];
    this.newModel.cabinList = [
      this.newModel.hasCabin1,
      this.newModel.hasCabin2,
      this.newModel.hasCabin3,
      this.newModel.hasCabin4
    ];

    this.newModel.assistants = this.newModel.assistants.map(a => {
      var assistantsIndex = 0;
      return this.assistants.find(e => {
        let found = e._id == a;
        this.newModel.assistantList[assistantsIndex] =
          this.newModel.assistantList[assistantsIndex++] || found;
        return found;
      });
    });

    this.newModel.availableOffers = this.newModel.availableOffers.map(a => {
      var offersIndex = 0;
      return this.offers.find(e => {
        let found = e._id == a;
        this.newModel.availableOfferList[offersIndex] =
          this.newModel.availableOfferList[offersIndex++] || found;
        return found;
      });
    });
    // console.log('newModel result', cloneDeep(this.newModel));

    this.showEditForm = true;
  }
  assistantListRequired() {
    return this.newModel.assistantList.filter(e => e).length == 0;
  }
  availableOfferListRequired() {
    return this.newModel.availableOfferList.filter(e => e).length == 0;
  }

  toggleAssistant(index, assistant) {
    if (this.newModel.assistantList[index]) {
      // console.log('assistant added', index, assistant);
      this.newModel.assistants.push(assistant);
    } else {
      this.newModel.assistants = this.newModel.assistants.filter(
        a => a._id !== assistant._id
      );
      // console.log('assistant removed', index, assistant, this.newModel.assistants);
    }
  }
  toggleOffer(index, offer) {
    if (this.newModel.availableOfferList[index]) {
      // console.log('aveilableOffer added', index, offer);
      this.newModel.availableOffers.push(offer);
    } else {
      this.newModel.availableOffers = this.newModel.availableOffers.filter(
        a => a._id !== offer._id
      );
      // console.log('aveilableOffer removed', index, offer, this.newModel.availableOffers);
    }
  }
  toggleCabin(index, cabin) {
    this.newModel[cabin] = !!this.newModel.cabinList[index];
  }
}



// WEBPACK FOOTER //
// ./client/app/manager/shops/shopCrud/shopCrud.controller.ts